import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Button, Typography} from 'views/components';
import {SimpleRefreshWidget, Translate, translate} from 'views/module';

import moment from 'moment';

const Header = (props) => {
  const {
    lastUpdatedAt,
    numRefresh,
    setLastUpdatedAt,
    setNumRefresh,
  } = props;

  const summaryLabel = translate('clientLead.ClientLeadList.Header.Summary', {
    updatedTime: moment(lastUpdatedAt).format('h:mm A'),
  });

  return (
    <Stack
      sx={{
        width: '100%',
        gap: '12px',
      }}
    >
      <Stack
        sx={{
          gap: '8px',
        }}
      >
        <Typography
          sx={{
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '28px',
            lineHeight: '36px',
            color: '#1A1916',
          }}
        >
          <Translate expression='clientLead.ClientLeadList.Title' />
        </Typography>
        <Stack
          direction={{md: 'row', xs: 'column'}}
          justifyContent='space-between'
          alignItems={{md: 'center', xs: 'flex-start'}}
          sx={{
            gap: '12px',
          }}
        >
          <Typography
            sx={{
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '13px',
              lineHeight: '17px',
              color: '#A8A49E',
            }}
          >
            {summaryLabel}
          </Typography>
          <Stack
            direction='row'
            alignItems='center'
            sx={{
              gap: '10px',
              flexWrap: 'wrap',
              ml: {md: 'auto', xs: 0},
            }}
          >
            <SimpleRefreshWidget
              numRefresh={numRefresh}
              setNumRefresh={setNumRefresh}
              setLastUpdatedAt={setLastUpdatedAt}
            />
            <Button
              href='/client/new'
              sx={{
                'minWidth': '64px',
                'height': '32px',
                'px': '10px',
                'py': '8px',
                'borderRadius': '7px',
                'backgroundColor': '#DA7955',
                'color': '#FFFFFF',
                'textTransform': 'none',
                'boxShadow': 'none',
                '&:hover': {
                  'backgroundColor': '#C96D4B',
                  'boxShadow': 'none',
                },
              }}
            >
              <Typography
                sx={{
                  fontStyle: 'normal',
                  fontWeight: 500,
                  fontSize: '12px',
                  lineHeight: '12px',
                  color: 'inherit',
                }}
              >
                <Translate expression='clientLead.ClientLeadList.Header.Action' />
              </Typography>
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

Header.propTypes = {
  lastUpdatedAt: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]).isRequired,
  numRefresh: PropTypes.number.isRequired,
  setLastUpdatedAt: PropTypes.func.isRequired,
  setNumRefresh: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Header));
